import script from "./JobStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./JobStatus.vue?vue&type=script&setup=true&lang=js"

import "./JobStatus.vue?vue&type=style&index=0&id=2fe9906a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe9906a"]])

export default __exports__